
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import { Heading2, BodyM } from '@casavo/base-ui'
import cn from 'classnames'
import { GetStaticProps, NextPage } from 'next'
import useTranslation from 'next-translate/useTranslation'
import Head from 'next/head'

import { CurvedLineDivider } from '@/components/CurvedLineDivider'
import { FullPageLayout } from '@/components/Layout'
import { Translated } from '@/components/Translated'
import { CitySelection } from '@/containers/SuggestedProperties'
import {
  suggestedPropertyFlowStepPaddingTop,
  suggestedPropertyFlowStepContent,
} from '@/containers/SuggestedProperties/Onboarding/Wizard/steps/styles.css'
import { CateCity, CitiesProvider } from '@/context/Cities'
import { sprinkles } from '@/design-lib/style-theme/sprinkles.css'
import { theme } from '@/design-lib/theme'
import { fetchCities } from '@/page-commons/citiesQuery'
import { backgroundColor, paddingTop } from '@/shared-styles/styles.css'
import { AreaDescription } from '@/types/graphql-generated-types'
import { getCountryFilterByLocale } from '@/utils/locale-variables'

type PageProps = {
  areas: AreaDescription[]
  cities: CateCity[]
}

const SuggestedOnboarding: NextPage<PageProps> = ({ areas, cities }) => {
  const { t } = useTranslation()
  return (
    <CitiesProvider {...{ areas, cities }}>
      <Head>
        <title>{t('main-search:MainSearch_SEO_Title')}</title>
        <meta content="noindex, nofollow" name="robots" />
      </Head>
      <FullPageLayout>
        <div className={cn(backgroundColor.lightBlue, suggestedPropertyFlowStepPaddingTop)}>
          <div
            className={cn(
              suggestedPropertyFlowStepContent,
              sprinkles({ paddingBottom: { desktop: '2xl', mobile: 'm' } })
            )}
          >
            <Heading2 className={paddingTop.xl}>{t('suggested:MainSearch_Intro_Title')}</Heading2>
            <BodyM className={paddingTop.m}>
              <Translated i18Key="suggested:MainSearch_Intro_Description" />
            </BodyM>
          </div>
        </div>
        <CurvedLineDivider lineSpacingColor={theme.colors.lightBlue} topColor="lightBlue" />
        <CitySelection />
      </FullPageLayout>
    </CitiesProvider>
  )
}

 const _getStaticProps: GetStaticProps = async (ctx) => {
  const countryFilter = {
    country: getCountryFilterByLocale(ctx.locale as Locale),
  }
  const citiesPartial = await fetchCities(countryFilter)
  const cities: CateCity[] = citiesPartial.map((city) => ({
    ...city,
    translatedCityName:
      city.translations.find((trans) => trans.language === ctx.locale)?.value ||
      city.translations.find((trans) => trans.language === 'en').value,
  }))
  const areaCapitals = cities.filter((city) => city.slug === city.referenceArea)
  const areas = Array.from(areaCapitals).map((capital) => ({
    cities: cities.filter((city) => city.referenceArea === capital.referenceArea),
    name:
      capital.translations.find((t) => t.language === ctx.locale)?.value ||
      capital.translations.find((t) => t.language === 'en').value,
    value: capital.name,
  }))

  return {
    props: {
      areas,
      cities,
    },
  }
}

export default SuggestedOnboarding


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/suggested/onboarding/index',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  